<template>
  <div class="unit-manage-container">
    <el-card class="unit-info-card">
      <div slot="header" class="card-header">
        <span>个人中心</span>
      </div>

      <div v-if="!isEditing" class="info-display">
        <div class="logo-container">
          <img :src="unitInfo.UnitLogo ? fileRootPath + unitInfo.UnitLogoFilePath : defaultLogo" alt="单位Logo"
            class="unit-logo" />
        </div>

        <el-descriptions :column="1" border :labelStyle="{ width: '300px' }">
          <el-descriptions-item label="用户名">{{ user.name }}</el-descriptions-item>
          <el-descriptions-item label="绑定手机号">
            <span v-if="user.phone != ''">{{ user.phone }}
              <label style="text-decoration: underline;font-size: 12px;color: blue;cursor: pointer;"
                @click="openChangePhoneDialog(1)">更换</label>
            </span>
            <span v-if="user.phone == ''" style="text-decoration: underline;color: blue;cursor: pointer;"
              @click="openChangePhoneDialog(2)">绑定</span>
          </el-descriptions-item>
          <el-descriptions-item label="单位/学校名称">{{ unitInfo.UnitName }}</el-descriptions-item>
          <el-descriptions-item label="单位/学校简称">{{ unitInfo.UnitSimpleName }}</el-descriptions-item>
          <el-descriptions-item label="单位/学校负责人">{{ unitInfo.UnitManagerName }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ unitInfo.UnitManagerPhone }}</el-descriptions-item>
          <el-descriptions-item label="联系邮箱">{{ unitInfo.UnitEmail }}</el-descriptions-item>
          <el-descriptions-item label="单位/学校地址">{{ unitInfo.UnitAddress }}</el-descriptions-item>
          <!-- <el-descriptions-item label="绑定微信">

          </el-descriptions-item> -->
        </el-descriptions>
        <div style="text-align: center;">
          <el-button type="primary" @click="startEdit">修改信息</el-button>
        </div>
      </div>

      <div v-else class="info-edit">
        <div class="logo-edit">
          <el-upload class="logo-uploader" action="" :http-request="customRequest" :show-file-list="false"
            :on-success="handleLogoSuccess" :before-upload="beforeLogoUpload" accept=".jpg,.png,.jpeg">
            <img v-if="unitForm.UnitLogo" :src="fileRootPath + unitForm.UnitLogoFilePath" class="unit-logo">
            <i v-else class="el-icon-plus logo-uploader-icon"></i>
            <div v-if="unitForm.UnitLogo" class="delete-logo" @click.stop="handleRemoveLogo">
              <i class="el-icon-delete"></i>
            </div>
          </el-upload>
          <div class="logo-tip">单位Logo</div>
        </div>

        <el-form :model="unitForm" label-width="120px" :rules="unitRules" ref="unitForm" class="edit-form"
          style="width: 80%;margin: 0 auto;">
          <el-form-item label="单位名称" prop="UnitName">
            <el-input v-model="unitForm.UnitName"></el-input>
          </el-form-item>
          <el-form-item label="单位简称">
            <el-input v-model="unitForm.UnitSimpleName"></el-input>
          </el-form-item>
          <el-form-item label="单位负责人" prop="UnitManagerName">
            <el-input v-model="unitForm.UnitManagerName"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="UnitManagerPhone">
            <el-input v-model="unitForm.UnitManagerPhone"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱">
            <el-input v-model="unitForm.UnitEmail"></el-input>
          </el-form-item>
          <el-form-item label="单位地址">
            <el-input v-model="unitForm.UnitAddress"></el-input>
          </el-form-item>
        </el-form>

        <div class="form-actions">
          <el-button type="primary" @click="saveUnitInfo">保存</el-button>
          <el-button type="info" @click="cancelEdit">取消</el-button>
        </div>
      </div>
    </el-card>
    <el-dialog title="绑定手机号" :visible.sync="bindPhoneDialogVisible" width="400px" :close-on-click-modal="false" >
      <el-form style="width: 90%;margin: 0 auto;" label-width="100px">
        <el-form-item label="手机号" v-if="phoneEditForm.step==1">
          {{phoneEditForm.currPhone}}
        </el-form-item>
        <el-form-item label="图片验证码" v-if="phoneEditForm.step == 1">
          <img style="position: absolute; z-index: 100;width: 100px;height: 35px;right: 5px;top: 5px;"
            @click="createRandomCodeImage()" class="code-image" :src="codeFilePath" />
          <el-input type="text" v-model="phoneEditForm.currImageCode" placeholder="图片验证码" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" v-if="phoneEditForm.step == 1">
          <el-input type="text" v-model="phoneEditForm.currCode" placeholder="短信验证码" maxlength="6"></el-input>
          <el-button class="code-btn" type="text" :disabled="'发送验证码' != btnText"
          @click="sendMobileCodeByAccId"
            style="position: absolute;right: 5px;top: 0;">{{
            btnText }}</el-button>
        </el-form-item>

        <el-form-item label="新手机号" v-if="phoneEditForm.step == 2">
          <el-input type="text" v-model="phoneEditForm.newPhone" placeholder="手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="图片验证码" v-if="phoneEditForm.step == 2">
          <img style="position: absolute; z-index: 100;width: 100px;height: 35px;right: 5px;top: 5px;"
            @click="createRandomCodeImage()" class="code-image" :src="codeFilePath" />
          <el-input type="text" v-model="phoneEditForm.newImageCode" placeholder="图片验证码" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" v-if="phoneEditForm.step == 2">
          <el-input type="text" v-model="phoneEditForm.newCode" placeholder="短信验证码" maxlength="6"></el-input>
          <el-button class="code-btn" type="text" :disabled="'发送验证码' != btnText"
            style="position: absolute;right: 5px;top: 0;"
            @click="sendMobileCode">{{
            btnText }}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" v-if="phoneEditForm.step == 1" @click="checkOldPhoneCode">验证</el-button>
        <el-button size="small" type="primary" v-if="phoneEditForm.step == 2" @click="submitBindNewPhone">提交</el-button>

        <el-button size="small" @click="bindPhoneDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<script>
import contestantServices from '@/request-server/request-services/contestant-services.js';
import SystemService from '@/request-server/request-services/system-services.js';
import Url from '@/request-server/request-url';
import { mapState } from 'vuex'
import userinfoServices from '../../../request-server/request-services/userinfo-services';
export default {
  data() {
    return {
      isEditing: false,
      defaultLogo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      unitInfo: {
        UnitId: '',
        UnitName: '',
        UnitSimpleName: '',
        UnitManagerName: '',
        UnitAddress: '',
        UnitManagerPhone: '',
        UnitEmail: '',
        UnitLogo: '',
        WeChatOpenId: '',
        WeChatNickName: ''
      },
      unitForm: {},
      unitRules: {
        UnitName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        UnitManagerName: [{ required: true, message: '请输入单位负责人', trigger: 'blur' }],
        UnitManagerPhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
      },
      fileRootPath: '',
      bindPhoneDialogVisible:false,
      codeId: '',
      codeFilePath: '',
      btnText: '发送验证码',
      lockSecond: 0,
      interval: null,
      phoneEditForm:{
        step:1,

        currPhone:'',
        currImageCode:'',
        currCode:'',

        newPhone: '',
        newImageCode: '',
        newCode: '',
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  created() {
    if(!this.$store.state.unitInfo.UnitId){
      this.getUnitInfo();
    }else{
      this.unitInfo = this.$store.state.unitInfo;
    }
    this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/';
  },
  methods: {
    getUnitInfo() {
      contestantServices.getUnitInfo().then(resData => {
        console.log(resData);
        if (resData.data) {
          this.unitInfo = resData.data;
          this.$store.commit("updateUnitInfo", resData.data);
        }
      })
    },
    startEdit() {
      this.unitForm = JSON.parse(JSON.stringify(this.unitInfo));
      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
    },
    saveUnitInfo() {
      this.$refs['unitForm'].validate((valid) => {
        if (valid) {
          console.log(this.unitForm);
          contestantServices.editUnitInfo(this.unitForm).then(resData => {
            console.log(resData);
            if (resData.code == 0) {
              this.$message.success(resData.data);
              this.cancelEdit();
              this.getUnitInfo();
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleLogoSuccess(res, file) {
      // 假设上传成功后服务器返回了图片URL
      this.unitForm.UnitLogo = res.url || URL.createObjectURL(file.raw);
    },

    customRequest(file) {
      const formData = new FormData();
      formData.append('files', file.file);
      formData.append('desc', 'unit-logos');
      formData.append('type', 'unit-logos');
      SystemService.uploadFiles(formData).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.unitForm.UnitLogo = res.data[0].FileId;
          this.unitForm.UnitLogoFilePath = 'unit-logos/' + res.data[0].FileId + res.data[0].FileSuffix;
        }
      })

    },
   

    beforeLogoUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPGOrPNG) {
        this.$message.error('上传Logo图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传Logo图片大小不能超过 5MB!');
      }
      return isJPGOrPNG && isLt5M;
    },
    handleRemoveLogo() {
      this.unitForm.UnitLogo = '';
      this.unitForm.UnitLogoFilePath = '';
    },
    createRandomCodeImage() {
      this.codeId = '';
      SystemService.createRandomCodeImage().then(resData => {
        if (resData.code === 0) {
          this.codeId = resData.data.code;
          this.codeFilePath = Url.getDownloadBaseUrl() + 'exportfiles/' + resData.data.fileName;
        }
      })
    },
    openChangePhoneDialog(step){
        this.phoneEditForm.step = step;
        this.phoneEditForm.currPhone = this.user.phone;
        this.phoneEditForm.currCode = '';
        this.phoneEditForm.currImageCode = '';
      if (this.interval !=null){
        clearInterval(this.interval);
        this.interval = null;
      }
      this.btnText='发送验证码';
        this.createRandomCodeImage();
        this.bindPhoneDialogVisible = true;
    },
    checkOldPhoneCode() {
      if(this.phoneEditForm.currCode == ''){
        this.$message.warning('请输入短信验证码');
        return
      }
      let data = {
        code:this.phoneEditForm.currCode,
        type:'check-curr-bind-phone'
      }
      userinfoServices.checkPhoneCode(data).then(resData=>{
        if(resData.code == 0){
          this.createRandomCodeImage();
          this.phoneEditForm.step = 2;
          this.phoneEditForm.newCode = '';
          this.phoneEditForm.newPhone = '';
          this.phoneEditForm.newImageCode = '';
          if (this.interval != null) {
            clearInterval(this.interval);
            this.interval = null;
          }
          this.btnText = '发送验证码';

        }
      })
    },
    submitBindNewPhone() {

      if (this.phoneEditForm.newPhone == '') {
        this.$message.warning('请输入手机号');
        return;
      }

      if (this.phoneEditForm.newCode == '') {
        this.$message.warning('请输入短信验证码');
        return;
      }


      let data = {
        phone: this.phoneEditForm.newPhone,
        code: this.phoneEditForm.newCode
      }

      userinfoServices.bindAccPhone(data).then(resData => {
        if (resData.code == 0) {
          this.$message.success(resData.data);
          this.bindPhoneDialogVisible = false;
          let phone = this.phoneEditForm.newPhone.substring(0, 3) + '****' + this.phoneEditForm.newPhone.substring(7)
          this.$store.commit('updateUserInfo', { LoginName: this.user.name, AccPhone: phone });
        }
      });
    },
    sendMobileCodeByAccId(){
      if(this.phoneEditForm.currImageCode == ''){
        this.$message.warning('请输入图形验证码');
        return;
      }

      let data = {
        codeId:this.codeId,
        code:this.phoneEditForm.currImageCode,
        type:'check-curr-bind-phone'
      }
      userinfoServices.sendMobileCodeByAccId(data).then(resData=>{
        if (resData.code == 0) {
          this.lockSecond = 60;
          this.btnText = this.lockSecond + 's';
          this.interval = setInterval(() => {
            if (this.lockSecond > 0) {
              this.lockSecond--;
              this.btnText = this.lockSecond + 's';
            } else {
              this.btnText = '发送验证码';
              clearInterval(this.interval);
              this.interval = null;
            }
          }, 1000);
        }
      })
    },
    sendMobileCode(){
      if (this.phoneEditForm.newPhone == '') {
        this.$message.warning('请输入手机号');
        return;
      }

      if (this.phoneEditForm.newImageCode == '') {
        this.$message.warning('请输入图形验证码');
        return;
      }

      let data = {
        codeId:this.codeId,
        code:this.phoneEditForm.newImageCode,
        phone:this.phoneEditForm.newPhone,
        type:'change-binding-phone'
      }

      userinfoServices.sendMobileCode(data).then(resData => {
        if (resData.code == 0) {
          this.lockSecond = 60;
          this.btnText = this.lockSecond + 's';
          this.interval = setInterval(() => {
            if (this.lockSecond > 0) {
              this.lockSecond--;
              this.btnText = this.lockSecond + 's';
            } else {
              this.btnText = '发送验证码';
              clearInterval(this.interval);
              this.interval = null;
            }
          }, 1000);
        }
      })
    }
  }
}
</script>

<style scoped>
.unit-manage-container {
  display: flex;
  justify-content: center;
}

.unit-info-card {
  width: 1000px;
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.info-display {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-display /deep/ .el-descriptions {
  font-size: 18px !important;
}

.info-display /deep/ .el-descriptions-item__label {
  color: #303133;
  font-weight: bold;
  background-color: #e3e3e3;
}

.info-display /deep/ .el-descriptions-item__content {
  color: #303133;
  font-size: 18px !important;
}

.info-display /deep/ .el-descriptions-border {
  border: 1px solid #c0c4cc;
}

.info-display /deep/ .el-descriptions-item__cell {
  border-color: #c0c4cc;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.unit-logo {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  object-fit: cover;

}

.edit-form /deep/ .el-form-item__label {
  font-size: 18px;
  color: #303133;
}

.edit-form /deep/ .el-input__inner {
  font-size: 18px;
  color: #303133;
  border-color: #c0c4cc;
}

.logo-edit {
  text-align: center;
  margin-bottom: 20px;
}

.logo-uploader {
  position: relative;
  width: 120px;
  margin: 0 auto;
}

.logo-uploader .el-upload {
  border: 1px dashed #c0c4cc;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: inline-block;
  position: relative !important;
}

.logo-uploader .el-upload:hover {
  border-color: #409EFF;
}

.logo-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.logo-tip {
  margin-top: 8px;
  color: #303133;
  font-size: 18px;
}

.form-actions {
  margin: 20px auto 0;
  gap: 10px;
  width: 80%;
  text-align: right;
}

.delete-logo {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 40px;
  height: 40px;
  background-color: #969696;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
}

.delete-logo i {
  color: white;
  font-size: 18px;
}

.delete-logo:hover {
  background-color: #f78989;
}

.el-descriptions /deep/ th {
  font-size: 16px !important;
}
</style>